module.exports = __webpack_public_path__ + "static/media/1015088.88d3249c.jpg";